export const onlineModels = [
  {
    id: 1,
    name: "美咲",
    age: 21,
    location: "渋谷区",
    distance: "0.5km",
    tags: ["ライブ配信中", "1対1チャット", "秘密のデート"],
    badge: "ライブ",
    image: "https://static.readdy.ai/image/2695ae454937f3378123a4b08a4022d8/43bbba54176a6135301d656e0982f63d.jpeg",
    videoPoster: "",
    isLive: true,
    isVerified: true,
  },
  {
    id: 2,
    name: "梨花",
    age: 23,
    location: "新宿区",
    distance: "1.2km",
    tags: ["VIPルーム", "エキゾチック", "ダンス好き"],
    badge: "VIP",
    image: "https://storage.readdy-site.link/project_files/684d9237-cffc-4b2c-8f08-109bf27051a9/146943e5-7630-417f-b26e-0731f1c6c5dd_compressed_photo_2026-07-20_02-01-37.webp",
    videoPoster: "",
    isLive: true,
    isVerified: true,
  },
  {
    id: 3,
    name: "彩乃",
    age: 22,
    location: "六本木",
    distance: "2.0km",
    tags: ["新人", "夢叶える", "甘えん坊"],
    badge: "新人",
    image: "https://static.readdy.ai/image/2695ae454937f3378123a4b08a4022d8/d8845b0ee657d58f0dc830b67685a600.jpeg",
    videoPoster: "",
    isLive: true,
    isVerified: true,
  },
];

export const gridModels = [
  {
    id: 4,
    name: "愛莉",
    age: 20,
    tags: ["ホット配信", "美ボディ"],
    badge: "ライブ",
    image: "https://static.readdy.ai/image/2695ae454937f3378123a4b08a4022d8/9f6979c9f88d405acdc24894a79cc1f7.png",
    isLive: true,
    isNew: false,
  },
  {
    id: 6,
    name: "結衣",
    age: 22,
    tags: ["女子大生", "甘いけど大胆"],
    badge: "NEW",
    image: "https://static.readdy.ai/image/2695ae454937f3378123a4b08a4022d8/ed845e52d3195345da7228b2d7a0deaf.png",
    isLive: false,
    isNew: true,
  },
  {
    id: 8,
    name: "真央",
    age: 25,
    tags: ["プレミアム", "夜会デート"],
    badge: "TOP",
    image: "https://static.readdy.ai/image/2695ae454937f3378123a4b08a4022d8/49009b7adaad29f62817bb19b9ca7282.png",
    isLive: true,
    isNew: false,
  },
  {
    id: 7,
    name: "陽菜",
    age: 21,
    tags: ["エロダンス", "何でもOK"],
    badge: "HOT",
    image: "https://storage.readdy-site.link/project_files/684d9237-cffc-4b2c-8f08-109bf27051a9/b113b39d-27a1-4a48-bf04-308affbf8ac6_compressed_photo_2026-07-20_02-20-26.webp",
    isLive: true,
    isNew: false,
  },
  {
    id: 9,
    name: "茜",
    age: 23,
    tags: ["秘密の遊び", "近所の子"],
    badge: "近所",
    image: "https://static.readdy.ai/image/2695ae454937f3378123a4b08a4022d8/c4f4a0ef455b5362c7d443ccaf50d579.png",
    isLive: true,
    isNew: false,
  },
  {
    id: 10,
    name: "美月",
    age: 22,
    tags: ["腰を振る", "激熱配信"],
    badge: "ライブ",
    image: "https://storage.readdy-site.link/project_files/684d9237-cffc-4b2c-8f08-109bf27051a9/a729b22a-f987-4b0b-9b99-51ed19ea0067_compressed_photo_2026-07-20_02-05-07.webp",
    isLive: true,
    isNew: false,
  },
  {
    id: 5,
    name: "凛",
    age: 24,
    tags: ["大人の魅力", "夜のお誘い"],
    badge: "18+",
    image: "https://static.readdy.ai/image/2695ae454937f3378123a4b08a4022d8/2640c96daa3c17f5c73932a7196565c4.jpeg",
    isLive: false,
    isNew: false,
  },
  {
    id: 11,
    name: "桜",
    age: 24,
    tags: ["シルクの肌", "甘えたい"],
    badge: "HOT",
    image: "https://storage.readdy-site.link/project_files/684d9237-cffc-4b2c-8f08-109bf27051a9/4b23b6cd-8518-45e9-b9c9-2bebd24f8e51_compressed_photo_2026-07-20_02-04-12.webp",
    isLive: true,
    isNew: false,
  },
];

export const stats = [
  { num: "+500k", label: "VIP会員" },
  { num: "10秒", label: "1対1ビデオチャット" },
  { num: "100%", label: "無料体験" },
];

export const features = [
  {
    icon: "ri-fire-line",
    title: "限定ショー",
    subtitle: "無修正、激熱コンテンツ",
  },
  {
    icon: "ri-map-pin-line",
    title: "あなたの近く",
    subtitle: "現実の出会いがあなたの街で",
  },
  {
    icon: "ri-shield-check-line",
    title: "100%プライベート",
    subtitle: "匿名で安全に楽しめる",
  },
];

export const urgency = {
  name: "カミラ",
  text: "\u3055\u308F\u3084\u304B\u306A\u30AB\u30DF\u30E9\u304C\u79D8\u5BC6\u306E\u90E8\u5C4B\u3092\u958B\u3051\u307E\u3057\u305F\uFF01\u4ECA\u3059\u3050\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30E9\u30A4\u30D6\u3067\u898B\u3066\u307F\u3066\uFF01",
  avatar: "https://readdy.ai/api/search-image?query=Close%20up%20portrait%20of%20beautiful%20young%20Japanese%20woman%20with%20bright%20smile%2C%20small%20square%20avatar%20size%2C%20clean%20background%2C%20friendly%20expression&width=64&height=64&seq=urgency-avatar&orientation=squarish",
};